import { ACTION_TYPES, MapSelectActionsReturn } from './actions'
import { MapSelectStateContextI } from './context'

export default function mapSelectReducer(
  state: MapSelectStateContextI,
  action: MapSelectActionsReturn
): MapSelectStateContextI {
  switch (action.type) {
    case ACTION_TYPES.TOGGLE_MAP_SLIDE_VISIBILITY:
      return {
        ...state,
        isSlideOpen: !state.isSlideOpen,
      }
    case ACTION_TYPES.TOGGLE_MAP_SIDEBAR_VISIBILITY:
      return {
        ...state,
        isSidebarOpen: action.payload.isSidebarOpen,
      }
    case ACTION_TYPES.TOGGLE_MAP_ZOOM_ALERT_MESSAGE:
      return {
        ...state,
        isZoomAlertMessageOpen: action.payload.isZoomAlertMessageOpen,
      }
    case ACTION_TYPES.SET_ADDRESS_LIST:
      return {
        ...state,
        addressList: action.payload.addressList,
      }
    case ACTION_TYPES.SET_SELECTED_MARKER:
      return {
        ...state,
        selectedMarker: action.payload.selectedMarker,
      }
    default:
      return state
  }
}
